import { API } from "./api";

export interface Scan {
  id: number;
  createdAt: Date;
}

export const convertScan = (s: API.Scan): Scan => {
  return {
    id: s.id,
    createdAt: new Date(s.created_at),
  }
}

export const convertScans = (s: API.Scan[]): Scan[] => {
  return s.map(convertScan).sort((a, b) => a.id - b.id)
}
